import { Container, Grid } from '@mui/material'
import { Form, Input, Submit } from "../Form";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { findStudent } from "../../features/students/studentsSlice";

export default function FormSearch(){
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const methods = useForm({ shouldUnregister: true })
    const onSubmit = values => dispatch(findStudent({ ...values, setError: methods.setError, navigate: navigate }));
    return(
        <Container maxWidth="xs" sx={{ mb: '2em' }}>
            <Form onSubmit={onSubmit} methods={methods}>
                <Grid container spacing={1}>
                    <Input name={'codigo'} label={'Buscar por código'} min={7} max={9} regEx={/[0-9A-Z]/g} />
                    <Submit title='Buscar....' />
                </Grid>
            </Form>
        </Container>
    )
}